import {
    api, C, sampleFields, sampleInventory, sampleTreatments,
    FRUITETI_CROPS, OPEN_FIELD_CROP_GROUPS, WMO_CODES,
    PERMANENT_CROP_KEYWORDS, OFFLINE_QUEUE_KEY
} from './context.js';
import { initWeather } from './weather.js';
import { renderSavedFieldsOnMap, updateFieldFormPermissions, refreshMapView } from './map.js';
import {
    populateTreatmentFieldOptions, populateTreatmentProductOptions,
    renderRecentTreatments, populateLogCropFilter, renderFullLogTable,
    renderInventoryTable, renderCarenzeCalendar, updateDashboardStats,
    updateOfflineQueueUI, renderOperatorsList, populateSettingsCompanyFields,
    initCampaignYear, resetLogFilters
} from './activities.js';
export async function loadApplicationData(campaignYear) {
    try {
        if (C.currentUser && C.currentUser.isDemo) {
        if (typeof C.map !== 'undefined' && C.map) {
            renderSavedFieldsOnMap();
            refreshMapView();
        }
        populateTreatmentFieldOptions();
            populateTreatmentProductOptions();
            renderRecentTreatments();
            populateLogCropFilter();
            renderFullLogTable();
            renderInventoryTable();
            renderCarenzeCalendar();
            updateDashboardStats();
            updateOfflineQueueUI();
            return;
        }

        const year = campaignYear || C.state.currentCampaignYear;
        const calYear = year ? year.substring(0, 4) : new Date().getFullYear().toString();

        const [fields, activities, allActivitiesOfYear, inventory] = await Promise.all([
            api.getFields(),
            api.getActivities(year),
            api.getActivities(calYear),
            api.getInventory()
        ]);
        
        C.state.fields = fields;
        C.state.treatments = activities;
        C.state.carenzeTreatments = allActivitiesOfYear;
        C.state.inventory = inventory;
        C.state.currentCampaignYear = year;

        resetLogFilters();

        // Aggiorna la mappa e le tabelle nella UI
        if (typeof C.map !== 'undefined' && C.map) {
            renderSavedFieldsOnMap();
            refreshMapView();
        }
        populateTreatmentFieldOptions();
        populateTreatmentProductOptions();
        renderRecentTreatments();
        populateLogCropFilter();
        renderFullLogTable();
        renderInventoryTable();
        renderCarenzeCalendar();
        updateDashboardStats();
        updateOfflineQueueUI();
        updateFieldFormPermissions();
        
        // Inizializza il meteo sulle coordinate reali dei terreni dell'azienda (es. Trasacco 41.958, 13.535)
        if (C.state.fields.length > 0 && C.state.fields[0].coords && C.state.fields[0].coords.length > 0) {
            const firstCoord = C.state.fields[0].coords[0];
            initWeather(firstCoord[0], firstCoord[1]);
        } else {
            initWeather(41.958, 13.535); // Default Italia centro-sud (Trasacco / Fucino)
        }

        if (C.currentUser && C.currentUser.role === 'admin') {
            await renderOperatorsList();
            populateSettingsCompanyFields();
            await initCampaignYear();
        }
    } catch (err) {
        console.error('Errore nel caricamento dei dati applicativi:', err);
        try {
            renderRecentTreatments();
            renderInventoryTable();
            updateDashboardStats();
        } catch (uiErr) {
            console.error('[AgriLog] refresh UI dopo errore load:', uiErr);
        }
    }
}
